import React from 'react';

export const WarningIcon = (): JSX.Element => {
  return (
    <svg
      width="24"
      height="26"
      viewBox="0 0 24 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 11.0317V14.617"
        stroke="#E8723B"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.805 5.2954L3.18561 18.9193C3.06422 19.1369 3.00022 19.3838 3 19.6351C2.99979 19.8864 3.06337 20.1333 3.18438 20.3512C3.30539 20.5691 3.47958 20.7502 3.6895 20.8764C3.89942 21.0026 4.1377 21.0695 4.38046 21.0704H19.6192C19.862 21.0695 20.1003 21.0026 20.3102 20.8764C20.5201 20.7502 20.6943 20.5691 20.8153 20.3512C20.9363 20.1333 20.9999 19.8864 20.9997 19.6351C20.9995 19.3838 20.9355 19.1369 20.8141 18.9193L13.1947 5.2954C13.0742 5.07748 12.9003 4.89637 12.6905 4.77042C12.4806 4.64446 12.2424 4.57812 11.9998 4.57812C11.7573 4.57812 11.5191 4.64446 11.3092 4.77042C11.0994 4.89637 10.9255 5.07748 10.805 5.2954V5.2954Z"
        stroke="#E8723B"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9999 18.9187C12.5738 18.9187 13.039 18.4372 13.039 17.8431C13.039 17.2491 12.5738 16.7676 11.9999 16.7676C11.4261 16.7676 10.9609 17.2491 10.9609 17.8431C10.9609 18.4372 11.4261 18.9187 11.9999 18.9187Z"
        fill="#E8723B"
      />
    </svg>
  );
};
